module.exports = __webpack_public_path__ + "9004690aa37baef537767149cd7b193d.pdf";